export const FETCH_AGENTS_START = 'FETCH_AGENTS_START';
export const FETCH_AGENTS_SUCCESS = 'FETCH_AGENTS_SUCCESS';
export const FETCH_AGENTS_ERROR = 'FETCH_AGENTS_ERROR';
export const CHOOSE_AGENT = 'CHOOSE_AGENT';
export const FETCH_AGENT_HOUSES = 'FETCH_AGENT_HOUSES';
export const FETCH_AGENTS_HOUSES_SUCCESS = 'FETCH_AGENTS_HOUSES_SUCCESS';
export const FETCH_AGENT_BY_ID = 'FETCH_AGENT_BY_ID';
// houses types
export const FETCH_HOUSES_START = 'FETCH_HOUSES_START';
export const FETCH_HOUSES_SUCCESS = 'FETCH_HOUSES_SUCCESS';
export const FETCH_HOUSES_ERROR = 'FETCH_HOUSES_ERROR';
export const CHOOSE_HOUSE = 'CHOOSE_HOUSE';
export const FETCH_HOUSE_BY_ID = 'FETCH_HOUSE_BY_ID';
// auth types
export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const SAVE_USER = 'SAVE_USER';
export const SAVE_TOKEN = 'SAVE_TOKEN';
